import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { SerialNumberRootParamList } from "../../../../types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { useAddItem } from "../../utils/sale-controller";

export type AddSerialNumberProductScreenProps = StackScreenProps<
  SerialNumberRootParamList,
  "AddSerialNumberProductScreen"
>;

export const AddSerialNumberProductScreen = ({
  navigation,
  route,
}: AddSerialNumberProductScreenProps) => {
  const addItem = useAddItem({ navigation });
  const { productId, defaultSerialNumber } = route.params;
  const shouldFocus = useHasTransitionEnded(navigation);
  const [value, setValue] = useState("");

  const isDirty = useMemo(() => {
    return value.length > 0;
  }, [value]);

  const isValid = useMemo(() => {
    return true;
  }, [value]);

  React.useEffect(() => {
    if (defaultSerialNumber) {
      setValue(defaultSerialNumber);
    }
  }, []);

  const handleOnSave = useCallback(async () => {
    if (isDirty && isValid) {
      addItem(productId, { serialNumber: value, skipVariantPicker: true })
        .then(() => navigation.getParent()?.goBack())
        .catch((err) => console.log(err));
    }
  }, [addItem, productId, isValid, isDirty, value]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      title: defaultSerialNumber ? "Add Serial Number" : "Add Serial Number",
      headerRight: ({}) => (
        <Button
          label="Add to cart"
          isAction
          disabled={disabled}
          onPress={handleOnSave}
          size="compact"
        ></Button>
      ),
    });
  }, [productId, isValid, isDirty, handleOnSave, defaultSerialNumber]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Serial number"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
        validationMessage={
          isValid ? undefined : "Please enter a valid serial number"
        }
      />
    </Page>
  );
};
